<template>
  <div class="flex h-screen items-center justify-center">
    <div class="text-gray-600 text-lg" v-if="loading">
      Preparazione della preview in corso...
    </div>
    <div class="text-gray-600 text-lg" v-else-if="error">
      {{ error }}
    </div>
    <div v-else class="h-full w-full">
      <div
        class="absolute transform -translate-x-1/2 -translate-y-1/2 z-0 text-gray-600 text-lg"
        style="top: 50%; left: 50%;"
      >
        Caricamento...
      </div>
      <iframe
        class="h-full w-full relative z-10"
        :src="previewSrc"
        border="0"
      />
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data() {
    return {
      loading: true,
      error: '',
    }
  },

  computed: {
    previewSrc() {
      return `/.netlify/functions/podcast-export-zip?tenant=${this.$route.params.tenant}&podcast=${this.$route.params.id}&token=${this.$store.state.user.profile.token}&preview=1`
    },
  },

  async created() {
    try {
      await axios.get('/.netlify/functions/podcast-json-save', {
        params: {
          podcast: this.$route.params.id,
          token: this.$store.state.user.profile.token,
          tenant: this.$route.params.tenant,
          preview: 1,
        },
      })
    } catch (err) {
      this.error =
        'Si è verificato un errore durante la generazione della preview. Riprova più tardi.'
    }

    this.loading = false
  },
}
</script>
